export const LOGIN_MUTATION = gql`
    mutation login($username: String!, $password: String!) {
        login(username: $username, password: $password) {
            # access_token
            __typename
            ... on LoginResponse {
                __typename
                access_token
            }
            ... on ValidUserResponse {
                __typename
                status
                user {
                    id
                    firstName
                    lastName
                    username
                    email
                    phoneNumber
                    role {
                        name
                        hierarchyLevel
                        permissions {
                            addPartner
                            viewPartner
                            editPartner
                            changePartnerStatus
                            addMerchant
                            addService
                            viewMerchant
                            editMerchant
                            cancelServices
                            changeMerchantStatus
                            unmaskPll
                            leadManagement
                            pricingAndProductManagement
                            reportingExcludingFinance
                            reportingIncludingFinance
                            stockManagement
                            viewFinance
                            viewCommissions
                            viewSelfBillingInvoices
                            addInvoice
                            addPayment
                            addCredit
                            partnerShop
                            serviceDesk
                            configurationUserManagement
                            configurationAuditLog
                            configurationFinance
                            configurationSage
                            managePartnerResources
                            configurationPartnerResources
                            configurationOther
                            customerSuccess
                        }
                    }
                    business {
                        id
                        hierarchyLevel
                        legalName
                        partnerId
                        partnerOfPartnerId
                    }
                    partner {
                        id
                    }
                    sellerId
                }
                access_token
            }
        }
    }
`;

export const RESET_PASSWORD_MUTATION = gql`
    mutation resetPassword($password: String!, $resetToken: String!) {
        resetPassword(password: $password, resetToken: $resetToken)
    }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
    mutation changePassword($currentPassword: String!, $newPassword: String!) {
        changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
            status
        }
    }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
    mutation forgotPassword($email: String!) {
        forgotPassword(email: $email)
    }
`;

export const VERIFY_USER_OTP_MUTATION = gql`
    mutation verifyUserOtp($otp: String!) {
        verifyUserOtp(otp: $otp) {
            status
            user {
                id
                firstName
                lastName
                username
                email
                phoneNumber
                role {
                    name
                    hierarchyLevel
                    permissions {
                        addPartner
                        viewPartner
                        editPartner
                        changePartnerStatus
                        addMerchant
                        addService
                        viewMerchant
                        editMerchant
                        cancelServices
                        changeMerchantStatus
                        unmaskPll
                        leadManagement
                        pricingAndProductManagement
                        reportingExcludingFinance
                        reportingIncludingFinance
                        stockManagement
                        viewFinance
                        viewCommissions
                        viewSelfBillingInvoices
                        addInvoice
                        addPayment
                        addCredit
                        partnerShop
                        serviceDesk
                        configurationUserManagement
                        configurationAuditLog
                        configurationFinance
                        configurationSage
                        managePartnerResources
                        configurationPartnerResources
                        configurationOther
                        customerSuccess
                    }
                }
                business {
                    id
                    hierarchyLevel
                    legalName
                    partnerId
                    partnerOfPartnerId
                }
                partner {
                    id
                    business {
                        id
                        legalName
                    }
                }
                sellerId
            }
            access_token
        }
    }
`;

export const RESEND_OTP_MUTATION = gql`
    mutation resendOtp {
        resendOtp
    }
`;

export const RESEND_EMAIL_INVITE = gql`
    mutation resendEmailInvite($id: Int!) {
        resendEmailInvite(id: $id) {
            id
            status
        }
    }
`;

export const RESET_TOKEN_EXPIRED = gql`
    mutation inviteExpired($resetToken: String!) {
        inviteExpired(resetToken: $resetToken)
    }
`;
